module.exports = __webpack_public_path__ + "img/Blumenwiese-380.1a769d40.jpg";